const list = {
    or: 'або',
    and: 'і',
    separator: ',',
};
export default Object.freeze(list);
